import { createComponent } from '@front/utils/alpine';

export default createComponent(() => ({
        expiry: 0,
        remaining: 0,

        init(expiry: number) {
            this.expiry = expiry;
            this.setRemaining()
            setInterval(() => {
                this.setRemaining();
            }, 1000);
        },

        setRemaining() {
            const diff = this.expiry - new Date().getTime();
            this.remaining =  parseInt("" + diff / 1000);
        },

        days() {
            return {
                value:this.remaining / 86400,
                remaining:this.remaining % 86400
            };
        },

        hours() {
            return {
                value:this.days().remaining / 3600,
                remaining:this.days().remaining % 3600
            };
        },

        minutes() {
            return {
                value:this.hours().remaining / 60,
                remaining:this.hours().remaining % 60
            };
        },

        seconds() {
            return {
                value:this.minutes().remaining,
            };
        },

        format(value: number) {
            const number = ("0" + parseInt("" +value)).slice(-2);
            return '<span class="w-6 inline-block text-center bg-gray-50">' + number.substring(0, 1) + '</span><span class="w-6 inline-block text-center bg-gray-50">' + number.substring(1, 2) + '</span>'
        },

        time() {
            return {
                days:this.format(this.days().value),
                hours:this.format(this.hours().value),
                minutes:this.format(this.minutes().value),
                seconds:this.format(this.seconds().value),
                remaining: this.remaining,
            }
        },
    })
);
